module.exports = __webpack_public_path__ + "static/img/guide.c2a6b8aa.png";